import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { BaseComponent } from '@libs/index';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';

interface MetaItem {
  value: string;
  shouldTranslate: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class SeoMetaService extends BaseComponent {
  private DEFAULT_TITLE = 'Beauty Booking';
  private DEFAULT_META_DESCRIPTION = 'home.meta.description';
  private META_DESCRIPTION_NAME = 'description';

  private currentTitle: MetaItem = {
    value: this.DEFAULT_TITLE,
    shouldTranslate: false,
  };
  private currentMetaDescription: MetaItem = {
    value: this.DEFAULT_META_DESCRIPTION,
    shouldTranslate: true,
  };

  constructor(
    private translateService: TranslateService,
    private titleService: Title,
    private metaService: Meta
  ) {
    super();

    this.translateService.onLangChange
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(() => {
        this.translateAndSetPageTitle();
        this.translateAndSetPageMetaDescription();
      });
  }

  public setTitle(title: string, shouldTranslate = true): void {
    this.currentTitle = {
      value: title || this.DEFAULT_TITLE,
      shouldTranslate: title ? shouldTranslate : false,
    };
    this.translateAndSetPageTitle();
  }

  public setMetaDescription(description: string, shouldTranslate = true): void {
    this.currentMetaDescription = {
      value: description || this.DEFAULT_META_DESCRIPTION,
      shouldTranslate: description ? shouldTranslate : true,
    };
    this.translateAndSetPageMetaDescription();
  }

  private translateAndSetPageTitle() {
    this.titleService.setTitle(
      this.currentTitle.shouldTranslate
        ? this.translateService.instant(this.currentTitle.value)
        : this.currentTitle.value
    );
  }

  private translateAndSetPageMetaDescription() {
    this.metaService.updateTag({
      name: this.META_DESCRIPTION_NAME,
      content: this.currentMetaDescription.shouldTranslate
        ? this.translateService.instant(this.currentMetaDescription.value)
        : this.currentMetaDescription.value,
    });
  }
}
